/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const FETCH_REVIEW_SUMMARY = 'FETCH_REVIEW_SUMMARY';
export const FETCH_REVIEW_SUMMARY_SUCCESS = 'FETCH_REVIEW_SUMMARY_SUCCESS';
export const FETCH_REVIEW_SUMMARY_ERROR = 'FETCH_REVIEW_SUMMARY_ERROR';
export const SET_FETCH_REVIEW_SUMMARY_STATUS = 'SET_FETCH_REVIEW_SUMMARY_STATUS';

export function fetchReviewSummarySuccess(data) {
    return {
        type: FETCH_REVIEW_SUMMARY_SUCCESS,
        payload: data,
    };
}
export function fetchReviewSummaryError(error) {
    return {
        type: FETCH_REVIEW_SUMMARY_ERROR,
        payload: error,
    };
}

export function setFetchReviewSummaryStatus(status) {
    return {
        type: SET_FETCH_REVIEW_SUMMARY_STATUS,
        payload: status,
    };
}

export function fetchReviewSummary(facilityId) {
    return {
        type: FETCH_REVIEW_SUMMARY,
        payload: facilityId,
    };
}
